<template>
	<header-block title="Test Page"></header-block>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Carousel</h3>
		<v-btn icon size="xx-small" @click="toggleSection('carousel')" class="ml-2">
			<v-icon>{{ sections.carousel ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.carousel">
		<SwipeCarousel :showArrows="false" :showButtons="true">
			<v-carousel-item>
				<v-row>
					<v-col>
						<AnalysisWidget 
						:fakeTotals="true" 
						:formatter="{format: v => '£' + v.toLocaleString()}" 
						titleLabel="Spending Analysis" 
						:title="true" 
						@click="this.$router.push('/SpendingAnalysis');" />
					</v-col>
				</v-row>
			</v-carousel-item>
			<v-carousel-item>
				<v-row>
					<v-col>
						<AccountsWidget :accounts="mockAccounts" :formatter="{format: v => '£' + v.toLocaleString()}" />
					</v-col>
				</v-row>
			</v-carousel-item>
		</SwipeCarousel>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Walkthrough</h3>
	</div>
	<MGButton v-if="sheetWalkthroughData" text="Open Walkthrough Drawer" @click="openWalkthroughDrawer" />
	<MGButton v-if="storyWalkthroughData" text="Open Story Page" @click="openStoryPage" class="ml-2" />

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Loader</h3>
		<v-btn icon size="xx-small" @click="toggleSection('loader')" class="ml-2">
			<v-icon>{{ sections.loader ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.loader">
		<v-checkbox
			v-model="loaderCustomer"
			label="Hide Loader"
			class="mb-4"
		></v-checkbox>
		<CustomerLoadWait :customer="loaderCustomer" />
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Tags</h3>
		<v-btn icon size="xx-small" @click="toggleSection('tags')" class="ml-2">
			<v-icon>{{ sections.tags ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.tags">
		<TagInput 
			:selectableTags="selectableTags"
			:modelValue="modelValue"
			maxTags="5"
			maxTagLength="10"
			@change="(tags) => console.log('Tags changed:', tags)"
			@addedNew="(tag) => console.log('New tag added:', tag)"
		/>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Numeric</h3>
		<v-btn icon size="xx-small" @click="toggleSection('numeric')" class="ml-2">
			<v-icon>{{ sections.numeric ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.numeric">
		<v-text-field type="text" label="Amount" v-model="amount" />
		Float: {{ parseFloat(amount) }} <br/>
		Float * 100: {{ parseFloat(amount) * 100 }}<br/>
		Rounded Float * 100: {{ Math.round(parseFloat(amount) * 100) }}<br/>
		Pence: {{ parseInt(Math.round(parseFloat(amount) * 100)) }}<br/>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Postcode</h3>
		<v-btn icon size="xx-small" @click="toggleSection('postcode')" class="ml-2">
			<v-icon>{{ sections.postcode ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.postcode">
		<AddressLookup theme="light" v-model="address" />
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Buttons</h3>
		<v-btn icon size="xx-small" @click="toggleSection('buttons')" class="ml-2">
			<v-icon>{{ sections.buttons ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.buttons">
		<BarArrowButton :icon="require('../assets/coins.png')" title="Bar Arrow Button" href="#" :large="true"/>
		<BarArrowButton title="Bar Arrow Button" href="#" :large="true"/>
		<MGButton text="Hello" />
		<MGButton text="Some Longer Text" />
		<MGButton :alt="true" text="Alt" />
		<MGButton :arrow="true" text="Arrow" />
		<MGButton :arrow="true" text="Long Text With Arrow" />
		<MGButton :icon="require('../assets/coins.png')" :arrow="true" text="Icon Arrow" />
		<MGButton :outline="true" :icon="require('../assets/coins.png')" :arrow="true" text="O I Arrow" />
		<MGButton :outline="true" :icon="require('../assets/coins.png')" :arrow="true" text="O I D" disabled="true" />
		<MGButton :alt="true" :arrow="true" text="Alt arrow" />
		<MGButton :icon="require('../assets/coins.png')" text="Icon" />
		<MGButton :icon="require('../assets/coins.png')" text="Icon disabled" disabled/>
		<MGButton :alt="true" :icon="require('../assets/coins.png')" text="Alt icon" />
		<MGButton :alt="true" :icon="require('../assets/coins.png')" :arrow="true" text="Alt icon arrow" />
		<MGButton :small="true" text="Small" />
		<MGButton :small="true" :outline="true" text="Small" />
		<MGButton :small="true" :alt="true" text="Small A" />
		<MGButton :small="true" :alt="true" :arrow="true" text="Small A A" />
		<MGButton :small="true" :icon="require('../assets/coins.png')" :alt="true" :arrow="true" text="Small I A A" />
		<MGButton :small="true" :icon="require('../assets/coins.png')" :alt="true" :arrow="true" text="Small I A A D" disabled="true" />
		<MGButton text="Down with icon" :arrow="false" :open="true" :icon="require('../assets/coins.png')"/>
		<MGButton text="Down no icon" :arrow="false" :open="true"/>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Swipe Actions</h3>
		<v-btn icon size="xx-small" @click="toggleSection('swipeActions')" class="ml-2">
			<v-icon>{{ sections.swipeActions ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.swipeActions" class="swipe-container">
		<SwipeActionsContainer
			:items="mockSwipeItems"
			:actions="[
					{
						icon: 'mdi-delete',
						type: 'delete',
						backgroundColor: 'var(--background-color-alt)'
					},
					{
						icon: 'mdi-pencil',
						type: 'edit',
						backgroundColor: 'var(--background-color-alt)'
					}
				]"
			:preview="false"
			@content-click="handleSwipeItemClick"
			@action-click="handleSwipeAction"
		>
			<template #default="{ item }">
				<div class="document-content">
					<div class="d-flex align-center">
						<v-icon class="docIcon" :icon="item.icon"></v-icon>
						<div class="flex-grow-1">
							<div class="docCol">{{ item.title }}</div>
							<div class="doc-date">{{ item.subtitle }}</div>
						</div>
						<v-icon size="small" color="grey">mdi-chevron-right</v-icon>
					</div>
				</div>
			</template>
		</SwipeActionsContainer>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">MGDialog</h3>
		<v-btn icon size="xx-small" @click="toggleSection('mgDialog')" class="ml-2">
			<v-icon>{{ sections.mgDialog ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.mgDialog">
		<MGButton text="Simple Dialog" @click="showSimpleDialog = true" class="mb-2" />
		<MGButton text="Form Dialog" @click="showFormDialog = true" class="mb-2" />
		<MGButton text="Multi-Page Dialog" @click="showMultiPageDialog = true" class="mb-2" />
		
		<!-- Simple Dialog Example -->
		<MGDialog v-model="showSimpleDialog" title="Simple Confirmation">
			<template #content>
				<p>This is a simple confirmation dialog with just text content.</p>
			</template>
			<template #actions>
				<MGButton :fullWidth="true" text="Confirm" @click="showSimpleDialog = false" />
				<MGButton :stacked="true" :fullWidth="true" :outline="true" text="Cancel" @click="showSimpleDialog = false" />
			</template>
		</MGDialog>

		<!-- Form Dialog Example -->
		<MGDialog v-model="showFormDialog" title="Form Example" max-width="500px">
			<template #content>
				<v-text-field v-model="formName" label="Name" class="mb-3" variant="solo" :flat="true" clearable single-line rounded outlined />
				<v-text-field v-model="formEmail" label="Email" type="email" variant="solo" :flat="true" clearable single-line rounded outlined />
			</template>
			<template #actions>
				<MGButton :fullWidth="true" text="Save" @click="saveForm" :disabled="!formName || !formEmail" />
				<MGButton :stacked="true" :fullWidth="true" :outline="true" text="Cancel" @click="showFormDialog = false" />
			</template>
		</MGDialog>

		<!-- Multi-Page Dialog Example -->
		<MGDialog v-model="showMultiPageDialog" title="Multi-Page Example" max-width="500px">
			<template #content>
				<!-- Page 1 -->
				<div v-if="currentPage === 1">
					<p class="mb-4">This is page 1 of a multi-page dialog.</p>
					<v-text-field v-model="page1Data" label="Page 1 Data" variant="solo" :flat="true" clearable single-line rounded outlined prefix="£" />
				</div>
				
				<!-- Page 2 -->
				<div v-if="currentPage === 2">
					<p class="mb-4">This is page 2 of a multi-page dialog.</p>
					<v-text-field v-model="page2Data" label="Page 2 Data" variant="solo" :flat="true" clearable single-line rounded outlined prefix="£" />
				</div>
			</template>
			<template #actions>
				<template v-if="currentPage === 1">
					<MGButton :fullWidth="true" text="Next" @click="currentPage = 2" :disabled="!page1Data" />
					<MGButton :stacked="true" :fullWidth="true" :outline="true" text="Cancel" @click="closeMultiPageDialog" />
				</template>
				<template v-if="currentPage === 2">
					<MGButton :fullWidth="true" text="Complete" @click="completeMultiPage" :disabled="!page2Data" />
					<MGButton :stacked="true" :fullWidth="true" :outline="true" text="Back" @click="currentPage = 1" />
				</template>
			</template>
		</MGDialog>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Savings Card</h3>
		<v-btn icon size="xx-small" @click="toggleSection('savingsCard')" class="ml-2">
			<v-icon>{{ sections.savingsCard ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.savingsCard">
		<div class="savings-card-container">
			<SavingsCard 
				:items="mockSavingsItems"
				:formatter="{format: v => '£' + v.toLocaleString()}"
			/>
		</div>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Month Selector</h3>
		<v-btn icon size="xx-small" @click="toggleSection('monthSelector')" class="ml-2">
			<v-icon>{{ sections.monthSelector ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.monthSelector">
		<div class="mb-4">
			<strong>Selected Month:</strong> {{ selectedMonth }}
		</div>
		<MonthSelector 
			v-model="selectedMonth"
			:slots="mockMonthSlots"
		/>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Pagination Dots</h3>
		<v-btn icon size="xx-small" @click="toggleSection('paginationDots')" class="ml-2">
			<v-icon>{{ sections.paginationDots ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.paginationDots">
		<div class="mb-4">
			<strong>Current Index:</strong> {{ paginationCurrentIndex }} / {{ paginationTotalItems }}
		</div>
		
		<div class="pagination-controls mb-4">
			<MGButton :small="true" text="Previous" @click="prevItem" :disabled="paginationCurrentIndex === 0" />
			<MGButton :small="true" text="Next" @click="nextItem" :disabled="paginationCurrentIndex === paginationTotalItems - 1" />
		</div>

		<div class="pagination-examples">
			<div class="example-section mb-4">
				<h4>5 Items (default maxDots)</h4>
				<PaginationDots
					:total-items="5"
					:current-index="Math.min(paginationCurrentIndex, 4)"
				/>
			</div>

			<div class="example-section mb-4">
				<h4>10 Items (shows sliding window)</h4>
				<PaginationDots
					:total-items="10"
					:current-index="Math.min(paginationCurrentIndex, 9)"
				/>
			</div>

			<div class="example-section mb-4">
				<h4>Custom maxDots (3)</h4>
				<PaginationDots
					:total-items="paginationTotalItems"
					:current-index="paginationCurrentIndex"
					:max-dots="3"
				/>
			</div>
		</div>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Smooth Scroll Container, Categories</h3>
		<v-btn icon size="xx-small" @click="toggleSection('smoothScroll')" class="ml-2">
			<v-icon>{{ sections.smoothScroll ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.smoothScroll">
		<SmoothScrollContainer>
			<div :class="'smoothScrollContainerItem'" v-for="(category, index) in mockCategories" :key="category.id">
				<CategoryButton
					:key="index"
					:title="category.title"
					:image="category.image"
					class="mr-4"
				/>
			</div>
		</SmoothScrollContainer>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Nav Panel</h3>
		<v-btn icon size="xx-small" @click="toggleSection('navPanel')" class="ml-2">
			<v-icon>{{ sections.navPanel ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.navPanel">
		<MGNavPanel title="Boosted" subtitle="Save whilst they last" :icon="require('@/assets/lightning-bolt.png')" @click="onNavPanelClick" />
	</div>

	<v-divider class="my-6"></v-divider>
	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Buy With Confidence Shout Panel</h3>
		<v-btn icon size="xx-small" @click="toggleSection('buyWithConfidence')" class="ml-2">
			<v-icon>{{ sections.buyWithConfidence ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.buyWithConfidence">
		<BuyWithConfidenceShoutPanel />
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Re-Link Accounts For Vouchers Shout Panel</h3>
		<v-btn icon size="xx-small" @click="toggleSection('reLinkAccountsForVouchers')" class="ml-2">
			<v-icon>{{ sections.reLinkAccountsForVouchers ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.reLinkAccountsForVouchers">
		<ReLinkAccountsForVouchersShoutPanel />
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Voucher Recommended For You</h3>
		<v-btn icon size="xx-small" @click="toggleSection('VoucherRecommendedForYou')" class="ml-2">
			<v-icon>{{ sections.VoucherRecommendedForYou ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<SwipeCarousel 
		:showArrows="false" 
		:showButtons="false" 
		:paginationDots="true"
		:height="'370px'"
		>
		<v-carousel-item v-show="sections.VoucherRecommendedForYou">
			<VoucherRecommendedForYou 
				:imageUrl="require('../assets/bg/Currys.png')"
				category="Technology"
				:isFavorited="true"
				spendLabel="Where you spent the most"
				merchantLogoUrl="https://s3.eu-west-2.amazonaws.com/content.sysodev.link/257ad329-Porthole.png"
				merchantName="Currys"
				spendInfo="June spend: £1,200"
				savingsAmount="10.50"
				savingsPercentage="5.5"
				:formatter="{format: v => '£' + v.toLocaleString()}" 
			/>
		</v-carousel-item>
		<v-carousel-item  v-show="sections.VoucherRecommendedForYou">
			<VoucherRecommendedForYou 
				:imageUrl="require('../assets/bg/Currys.png')"
				category="Technology"
				:isFavorited="true"
				spendLabel="Where you spent the most"
				merchantLogoUrl="https://s3.eu-west-2.amazonaws.com/content.sysodev.link/257ad329-Porthole.png"
				merchantName="Currys"
				spendInfo="June spend: £1,200"
				savingsAmount="10.50"
				savingsPercentage="5.5"
				:formatter="{format: v => '£' + v.toLocaleString()}" 
			/>
		</v-carousel-item>

	</SwipeCarousel>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Voucher Recommended For You Small</h3>
		<v-btn icon size="xx-small" @click="toggleSection('VoucherRecommendedForYouSmall')" class="ml-2">
			<v-icon>{{ sections.VoucherRecommendedForYouSmall ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.VoucherRecommendedForYouSmall">
		<SmoothScrollContainer>
			<div :class="'smoothScrollContainerItem'" v-for="(category, index) in mockCategories" :key="category.id">
				<VoucherRecommendedForYou 
					:key="index"
					image-url="https://s3.eu-west-2.amazonaws.com/content.sysodev.link/358f1c73-Technology.png"
					:isFavorited="true"
					merchant-logo-url="https://assets.sandbox.tillo.dev/images/brands/vouchers/330x214/cote-brasserie.jpg"
					merchant-name="Currys"
					spend-info="June spend: £1,200"
					savings-amount="£10.50"
					savings-percentage="5.5%"
					:small="true"
					:formatter="{format: v => '£' + v.toLocaleString()}"
				/>
			</div>
		</SmoothScrollContainer>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Saving Opportunity Card</h3>
		<v-btn icon size="xx-small" @click="toggleSection('savingOpportunityCard')" class="ml-2">
			<v-icon>{{ sections.savingOpportunityCard ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.savingOpportunityCard">
		<SmoothScrollContainer>
			<div :class="'smoothScrollContainerItem'"  v-for="(item, index) in mockSavingOpportunities" :key="index" class="mr-2">
				<VoucherSavingSuggestions
					:key="index"
					:labelValue="item.totalSpendAmount"
					:label="item.totalSpendLabel"
					:logoUrl="item.logoUrl"
					:logoAltText="item.logoAltText"
					:savingAmount="item.savingAmount"
					:savingPercentage="item.savingPercentage"
					:logoBackgroundColor="item.logoBackgroundColor"
				/>
			</div>
		</SmoothScrollContainer>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Voucher Merchant Card</h3>
		<v-btn icon size="xx-small" @click="toggleSection('merchantCard')" class="ml-2">
			<v-icon>{{ sections.merchantCard ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.merchantCard">
		<SmoothScrollContainer>
			<div :class="'smoothScrollContainerItem'" v-for="(card, index) in mockMerchantCards" :key="index" class="mr-2">
				<VoucherMerchantCard
					:logoUrl="card.logoUrl"
					:merchantName="card.merchantName"
					:savingPercentage="card.savingPercentage"
					:isFavorited="card.isFavorited"
				/>
			</div>
		</SmoothScrollContainer>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Section Header</h3>
		<v-btn icon size="xx-small" @click="toggleSection('sectionHeader')" class="ml-2">
			<v-icon>{{ sections.sectionHeader ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.sectionHeader">
		<SectionHeader 
			title="Categories" 
			subtitle="Discover how you can save" 
			actionLabel="View all"
			@action="onSectionHeaderAction"
		/>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Voucher Basket</h3>
		<v-btn icon size="xx-small" @click="toggleSection('voucherBasket')" class="ml-2">
			<v-icon>{{ sections.voucherBasket ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.voucherBasket">
		<div class="voucher-basket-examples">
			<div class="example-section mb-4">
				<h4>Default Configuration</h4>
				<VoucherBasket @click="handleVoucherBasketClick('default')" />
			</div>

			<div class="example-section mb-4">
				<h4>Multiple Vouchers</h4>
				<VoucherBasket 
					:voucherCount="3"
					:totalAmount="250.50"
					@click="handleVoucherBasketClick('multiple')" 
				/>
			</div>

			<div class="example-section mb-4">
				<h4>Custom Text</h4>
				<VoucherBasket 
					:voucherCount="2"
					:totalAmount="75.99"
					basketText="Complete purchase"
					@click="handleVoucherBasketClick('custom')" 
				/>
			</div>

			<div class="example-section mb-4">
				<h4>Large Amount</h4>
				<VoucherBasket 
					:voucherCount="5"
					:totalAmount="1234.56"
					basketText="Proceed to checkout"
					@click="handleVoucherBasketClick('large')" 
				/>
			</div>
		</div>
	</div>

	<v-divider class="my-6"></v-divider>

	<!-- <div class="d-flex align-center mb-4">
		<h3 class="mb-0">Voucher Edit Form</h3>
		<v-btn icon size="xx-small" @click="toggleSection('voucherEditForm')" class="ml-2">
			<v-icon>{{ sections.voucherEditForm ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.voucherEditForm">
		<div class="voucher-edit-form-examples">
			<div class="example-section mb-4">
				<h4>Default Airbnb Example</h4>
				<VoucherEditForm 
					@close="handleEditFormClose"
					@update="handleEditFormUpdate"
				/>
			</div>

			<div class="example-section mb-4">
				<h4>Sainsbury's Example</h4>
				<VoucherEditForm 
					merchantName="Sainsbury's"
					logoUrl="https://s3.eu-west-2.amazonaws.com/content.sysodev.link/3e242bda-SainsburysPorthole.png"
					:initialAmount="75"
					:cashbackPercentage="4.2"
					@close="handleEditFormClose"
					@update="handleEditFormUpdate"
				/>
			</div>

			<div class="example-section mb-4">
				<h4>Currys Example</h4>
				<VoucherEditForm 
					merchantName="Currys"
					logoUrl="https://s3.eu-west-2.amazonaws.com/content.sysodev.link/257ad329-Porthole.png"
					:initialAmount="200"
					:cashbackPercentage="6.0"
					@close="handleEditFormClose"
					@update="handleEditFormUpdate"
				/>
			</div>
		</div>
	</div> -->

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Card Account Group</h3>
		<v-btn icon size="xx-small" @click="toggleSection('cardAccountGroup')" class="ml-2">
			<v-icon>{{ sections.cardAccountGroup ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.cardAccountGroup">
		<div class="card-account-group-container">
			<CardAccountGroup
				v-for="(card, index) in mockCardAccountGroups"
				:key="index"
				:card-title="card.cardTitle"
				:amount="card.amount"
				:illustration-url="card.illustrationUrl"
				:account-avatars="card.accountAvatars"
				:formatter="{ format: v => '£' + v.toLocaleString() }"
				class="mr-4"
			/>
		</div>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Account List Item</h3>
		<v-btn icon size="xx-small" @click="toggleSection('accountListItem')" class="ml-2">
			<v-icon>{{ sections.accountListItem ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.accountListItem">
		<div class="account-list-items-container">
			<AccountListItem
				v-for="(account, index) in mockAccountListItems"
				:key="index"
				:provider-name="account.bankName"
				:line1="account.accountType"
				:line2="account.accountNumber"
				:balance="account.balance"
				:avatar-url="account.avatarUrl"
				:badge-url="account.badgeUrl"
				:formatter="{ format: v => '£' + v.toLocaleString() }"
				@click="handleAccountListItemClick(account)"
				class="mb-3"
			/>
		</div>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Account Type Lozenge</h3>
		<v-btn icon size="xx-small" @click="toggleSection('accountTypeLozenge')" class="ml-2">
			<v-icon>{{ sections.accountTypeLozenge ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.accountTypeLozenge">
		<div class="account-type-lozenge-container">
			<AccountTypeLozenge
				v-for="(lozenge, index) in mockAccountTypeLozenges"
				:key="index"
				:account-type="lozenge.accountType"
				:account-count="lozenge.accountCount"
				:icon-url="lozenge.iconUrl"
				:is-add-button="lozenge.isAddButton"
				@click="handleAccountTypeLozengeClick"
			/>
		</div>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Saved to Spend Balance</h3>
		<v-btn icon size="xx-small" @click="toggleSection('savedToSpendBalance')" class="ml-2">
			<v-icon>{{ sections.savedToSpendBalance ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.savedToSpendBalance">
		<SavedToSpendBalance
			:balance="0.25"
			:stat1Value="640.35"
			:stat2Value="1230.20"
			stat3Value="7%"
			:formatter="{ format: v => '£' + v.toFixed(2) }"
			@shop-click="handleShopClick"
		/>
	</div>

	<v-divider class="my-6"></v-divider>

	<div class="d-flex align-center mb-4">
		<h3 class="mb-0">Recent Discount Transactions</h3>
		<v-btn icon size="xx-small" @click="toggleSection('recentDiscountTransactions')" class="ml-2">
			<v-icon>{{ sections.recentDiscountTransactions ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
		</v-btn>
	</div>
	<div v-show="sections.recentDiscountTransactions">
		<DiscountTransactionsSection
			:days="mockTransactionDays"
			:maxDays="3"
			:formatter="{ format: v => '£' + v.toFixed(2) }"
			@view-more="handleViewMoreTransactions"
		/>
	</div>

	<WalkthroughDrawerPanel
		ref="walkthroughDrawer"
		:walkthroughData="sheetWalkthroughData"
		variant="sheet"
		@drawer-opened="handleWalkthroughOpened"
		@drawer-closed="handleWalkthroughClosed"
	/>



</template>

<script>
import Services from '../mixins/Services';
import AddressLookup from './elements/AddressLookup.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import BarArrowButton from './elements/BarArrowButton.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import TagInput from './elements/TagInput.vue';
import SwipeCarousel from './elements/SwipeCarousel.vue';
import AnalysisWidget from './elements/AnalysisWidget.vue';
import AccountsWidget from './elements/AccountsWidget.vue';
import SwipeActionsContainer from './elements/SwipeActionsContainer.vue';
import MGDialog from './elements/MGDialog.vue';
import SavingsCard from './elements/SavingsCard.vue';
import MonthSelector from './elements/MonthSelector.vue';
import PaginationDots from './elements/PaginationDots.vue';
import SmoothScrollContainer from './elements/SmoothScrollContainer.vue';
import CategoryButton from './elements/CategoryButton.vue';
import MGNavPanel from './elements/MGNavPanel.vue';
import BuyWithConfidenceShoutPanel from './elements/BuyWithConfidenceShoutPanel.vue';
import ReLinkAccountsForVouchersShoutPanel from './elements/ReLinkAccountsForVouchersShoutPanel.vue';
import VoucherRecommendedForYou from './elements/VoucherRecommendedForYou.vue';
import VoucherSavingSuggestions from './elements/VoucherSavingSuggestions.vue';
import VoucherMerchantCard from './elements/VoucherMerchantCard.vue';
import SectionHeader from './elements/SectionHeader.vue';
import VoucherBasket from './elements/VoucherBasket.vue';
import CardAccountGroup from './elements/CardAccountGroup.vue';
import AccountListItem from './elements/AccountListItem.vue';
import AccountTypeLozenge from './elements/AccountTypeLozenge.vue';
// import VoucherEditForm from './elements/VoucherEditForm.vue';
import WalkthroughDrawerPanel from './elements/WalkthroughDrawerPanel.vue';
import SavedToSpendBalance from './elements/SavedToSpendBalance.vue';
import DiscountTransactionsSection from './elements/DiscountTransactionsSection.vue';


export default {
	mixins: [Services],
	components: {HeaderBlock, MGButton, AddressLookup, BarArrowButton, CustomerLoadWait, TagInput, SwipeCarousel, AnalysisWidget, AccountsWidget, SwipeActionsContainer, MGDialog, SavingsCard, MonthSelector, PaginationDots,
		SmoothScrollContainer,
		CategoryButton,
		MGNavPanel,
		BuyWithConfidenceShoutPanel,
		ReLinkAccountsForVouchersShoutPanel,
		VoucherRecommendedForYou,
		CardAccountGroup, AccountListItem, AccountTypeLozenge,
		VoucherSavingSuggestions, VoucherMerchantCard, SectionHeader, VoucherBasket, WalkthroughDrawerPanel,
		SavedToSpendBalance, DiscountTransactionsSection
		// , VoucherEditForm
	},
	data() {
		return {
			sections: {
				carousel: false,
				loader: false,
				tags: false,
				numeric: false,
				postcode: false,
				buttons: false,
				swipeActions: false,
				mgDialog: false,
				savingsCard: false,
				monthSelector: false,
				paginationDots: false,
				smoothScroll: false,
				navPanel: false,
				buyWithConfidence: false,
				VoucherRecommendedForYou: false,
				VoucherRecommendedForYouSmall: false,
				savingOpportunityCard: false,
				merchantCard: false,
				sectionHeader: true,
				voucherBasket: false,
				voucherEditForm: false,
				cardAccountGroup: false,
				accountListItem: false,
				accountTypeLozenge: false,
				savedToSpendBalance: false,
				recentDiscountTransactions: false,
			},
			loaderCustomer: true,
			drawer: false,
			rail: true,
			currentAccounts: [],
			currentAccountsBalance: 0,
			creditAccounts: [],
			creditAccountsBalance: 0,
			savingsAccounts: [],
			savingsAccountsBalance: 0,
			selectableTags: ['vue', 'vueJs', 'javascript', 'typescript', 'wibble', 'foo', 'bar', 'baz', 'qux', 'quux', 'corge', 'grault', 'garply', 'waldo', 'fred', 'plugh', 'xyzzy', 'thud'],
			modelValue: ['vue', 'vueJs'],
			address:null,
			amount:0,
			sheetWalkthroughData: null,
			storyWalkthroughData: null,
			mockTotals: [
				{ id: 0, Amount: 2890 }, // INCOME
				{ id: 1, Amount: 100 },  // FUTURE_PLANNING
				{ id: 2, Amount: 400 },  // EVERYDAY_SPEND
				{ id: 3, Amount: 2600 }  // FIXED_COSTS
			],
			mockAccounts: [
{
	"id": "08dd7d15-cd62-45be-85d4-42866ca80ca7",
	"bank": {
	"id": "08dce6ad-fe1a-45a8-8cdd-394366150346",
	"name": "FIRST-DIRECT",
	"prettyName": null,
	"logoUri": "https://truelayer-client-logos.s3-eu-west-1.amazonaws.com/banks/banks-icons/ob-first-direct-icon.svg",
	"logoPath": null,
	"hexColour1": null,
	"hexColour2": null,
	"invertCreditCardBalance": true
	},
	"accountType": {
	"id": "08da73f8-64b3-4b3d-842e-45f574933979",
	"name": "TRANSACTION",
	"prettyName": "Current",
	"prettyLongName": "Current account",
	"dashIconPath": "currentAccountIcon.svg",
	"smallIconPath": "currentAccountIconMoney.svg"
	},
	"directDebits": null,
	"usageType": null,
	"groupedTransactions": null,
	"customerID": "08dd6557-20ff-4b94-87b4-dd3c9e04000a",
	"source": 0,
	"jointStatus": 0,
	"accountTypeDisplayName": "TRANSACTION",
	"card": false,
	"displayName": null,
	"bankDisplayName": "FIRST-DIRECT",
	"accountNumber": "34133501",
	"sortCode": "40-47-83",
	"providerAccountID": "64d1c1f3b75939192064e57ffcc7eaed",
	"currency": "GBP",
	"createDateTime": "2025-04-16T18:37:54.991505",
	"balance": 5455.63,
	"available": 5781.55,
	"overdraftFacility": 500,
	"lastRefreshed": "2025-05-08T06:00:12.580599",
	"consentExpired": false,
	"consentRefreshFailed": false,
	"relevance": 1
}
],
			mockSwipeItems: [
				{
					id: 1,
					title: 'Document 1',
					subtitle: 'Created 2 hours ago',
					icon: 'mdi-file-document-outline'
				},
				{
					id: 2,
					title: 'Document 2',
					subtitle: 'Created yesterday',
					icon: 'mdi-file-pdf-box'
				},
				{
					id: 3,
					title: 'Document 3',
					subtitle: 'Created 3 days ago',
					icon: 'mdi-file-word'
				}
			],
			showSimpleDialog: false,
			showFormDialog: false,
			showMultiPageDialog: false,
			currentPage: 1,
			page1Data: '',
			page2Data: '',
			formName: '',
			formEmail: '',
			mockSavingsItems: [
				{
					value: 2240,
					label: 'Saved to spend'
				},
				{
					value: 1850,
					label: 'Saved this month'
				},
				{
					value: 12500,
					label: 'All time savings'
				}
			],
			selectedMonth: 'July 2025',
			mockMonthSlots: [
				{ key: 'May 2024', label: 'May' },
				{ key: 'June 2024', label: 'Jun' },
				{ key: 'July 2024', label: 'Jul' },
				{ key: 'August 2024', label: 'Aug' },
				{ key: 'September 2024', label: 'Sep' },
				{ key: 'October 2024', label: 'Oct' },
				{ key: 'November 2024', label: 'Nov' },
				{ key: 'December 2024', label: 'Dec' },
				{ key: 'January 2025', label: 'Jan' },
				{ key: 'February 2025', label: 'Feb' },
				{ key: 'March 2025', label: 'Mar' },
				{ key: 'April 2025', label: 'Apr' },
				{ key: 'May 2025', label: 'May' },
				{ key: 'June 2025', label: 'Jun' },
				{ key: 'July 2025', label: 'Jul' },
				{ key: 'August 2025', label: 'Aug' },
				{ key: 'September 2025', label: 'Sep' },
				{ key: 'October 2025', label: 'Oct' },
				{ key: 'November 2025', label: 'Nov' },
				{ key: 'December 2025', label: 'Dec' },
				{ key: 'January 2026', label: 'Jan' },
				{ key: 'February 2026', label: 'Feb' }
			],
			paginationCurrentIndex: 0,
			paginationTotalItems: 7,
			mockCategories: [
				{ title: 'Bakery & Coffee', image: require('../assets/categories/bakery-coffee.png') },
				{ title: 'Entertainment', image: require('../assets/categories/entertainment.png') },
				{ title: 'Family', image: require('../assets/categories/family.png') },
				{ title: 'Fashion', image: require('../assets/categories/fashion.png') },
				{ title: 'Gifts', image: require('../assets/categories/gifts.png') },
				{ title: 'Home & Garden', image: require('../assets/categories/home-garden.png') },
				{ title: 'Hotels', image: require('../assets/categories/hotels.png') },
				{ title: 'Leisure', image: require('../assets/categories/leisure.png') }
			],
			mockSavingOpportunities: [
				{
						totalSpendAmount: '£4,400',
						logoUrl: 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/3e242bda-SainsburysPorthole.png',
						logoAltText: 'Sainsbury\'s',
						savingAmount: '£124.25',
						savingPercentage: '5.5%',
						logoBackgroundColor: '#F07F00',
						totalSpendLabel: 'Total Spend'
				},
				{
						logoUrl: 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/257ad329-Porthole.png',
						logoAltText: 'Airbnb',
						savingAmount: '£100.00',
						savingPercentage: '5.5%',
						logoBackgroundColor: '#FF5A5F',
						totalSpendLabel: 'Biggest Single Saving'
				},
				{
						totalSpendAmount: '£3,200',
						logoUrl: 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/5a6b0438-Sainsbury%27s.png',
						logoAltText: 'Sainsbury\'s',
						savingAmount: '£88.50',
						savingPercentage: '4.2%',
						logoBackgroundColor: '#F07F00'
				}
			],
			mockMerchantCards: [
        {
          logoUrl: 'https://assets.sandbox.tillo.dev/images/brands/vouchers/330x214/airbnb.jpg',
          merchantName: 'Airbnb',
          savingPercentage: '5.5%',
          isFavorited: true
        },
        {
          logoUrl: 'https://assets.sandbox.tillo.dev/images/brands/vouchers/330x214/airbnb.jpg',
          merchantName: 'Adidas',
          savingPercentage: '12.5%',
          isFavorited: false
        },
        {
          logoUrl: 'https://assets.sandbox.tillo.dev/images/brands/vouchers/330x214/airbnb.jpg',
          merchantName: 'Sainsbury\'s',
          savingPercentage: '4.2%',
          isFavorited: true
        },
      ],
			mockCardAccountGroups: [
				{
					cardTitle: 'Investments',
					amount: 3722.00,
					illustrationUrl: 'https://www.figma.com/api/mcp/asset/fe1b4776-7d41-4ea1-a1cc-55d5581780d3',
					accountAvatars: [
						{
							url: 'https://www.figma.com/api/mcp/asset/1142ec1a-a7c8-41be-8c81-48babbbbdbaf',
							alt: 'Avatar 1'
						},
						{
							url: 'https://www.figma.com/api/mcp/asset/af21fedd-28d5-482a-857b-f64fd5557e64',
							alt: 'Avatar 2'
						},
						{
							url: 'https://www.figma.com/api/mcp/asset/1142ec1a-a7c8-41be-8c81-48babbbbdbaf',
							alt: 'Avatar 3'
						}
					]
				},
				{
					cardTitle: 'Savings',
					amount: 1500.50,
					illustrationUrl: 'https://www.figma.com/api/mcp/asset/fe1b4776-7d41-4ea1-a1cc-55d5581780d3',
					accountAvatars: [
						{
							url: 'https://www.figma.com/api/mcp/asset/af21fedd-28d5-482a-857b-f64fd5557e64',
							alt: 'Avatar 1'
						},
						{
							url: 'https://www.figma.com/api/mcp/asset/1142ec1a-a7c8-41be-8c81-48babbbbdbaf',
							alt: 'Avatar 2'
						}
					]
				}
			],
			mockAccountListItems: [
				{
					bankName: 'Monzo',
					accountType: 'Current Account',
					accountNumber: '*****345',
					balance: 522.00,
					// avatarUrl: require('@/assets/thumbnails/monzo-avatar.png'),
					badgeUrl: require('@/assets/thumbnails/badge.png')
				},
				{
					bankName: 'HSBC',
					accountType: 'Savings Account',
					accountNumber: '*****678',
					balance: 1250.75,
					// avatarUrl: require('@/assets/thumbnails/monzo-avatar.png'),
					badgeUrl: ''
				},
				{
					bankName: 'Barclays',
					accountType: 'Current Account',
					accountNumber: '*****901',
					balance: 3456.50,
					// avatarUrl: require('@/assets/thumbnails/monzo-avatar.png'),
					badgeUrl: require('@/assets/thumbnails/badge.png')
				}
			],
			mockAccountTypeLozenges: [
				{
					accountType: 'Current Account',
					accountCount: 2,
					// iconUrl: require('@/assets/thumbnails/current-account.svg'),
					isAddButton: false
				},
				{
					accountType: 'Credit Card',
					accountCount: 2,
					// iconUrl: require('@/assets/thumbnails/credit-card.svg'),
					isAddButton: false
				},
				{
					accountType: 'Savings',
					accountCount: 8,
					// iconUrl: require('@/assets/thumbnails/savings.svg'),
					isAddButton: false
				},
				{
					accountType: 'Investments',
					accountCount: null,
					// iconUrl: require('@/assets/thumbnails/investments.svg'),
					isAddButton: true
				},
				{
					accountType: 'Pension',
					accountCount: null,
					// iconUrl: require('@/assets/thumbnails/pension.svg'),
					isAddButton: true
				},
				{
					accountType: 'Mortgage',
					accountCount: 2,
					// iconUrl: require('@/assets/thumbnails/mortgage.svg'),
					isAddButton: false
				},
				{
					accountType: 'Loans',
					accountCount: null,
					// iconUrl: require('@/assets/thumbnails/loans.svg'),
					isAddButton: true
				},
				{
					accountType: 'Insurance Policy',
					accountCount: null,
					// iconUrl: require('@/assets/thumbnails/insurance-policy.svg'),
					isAddButton: true
				}
			],
			mockTransactionDays: [
				{
					date: '2026-01-13T00:00:00',
					purchases: [
						{
							merchantName: 'Waitrose & Partners',
							icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/waitrose.jpg',
							faceValue: 123,
							savedToSpendEarningsAmount: 3.08,
							savingPercentage: 2.5,
							usedSavedToSpend: null
						},
						{
							merchantName: 'Amazon',
							icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/amazon.jpg',
							faceValue: 12,
							savedToSpendEarningsAmount: 0.24,
							savingPercentage: 2,
							usedSavedToSpend: null
						}
					]
				},
				{
					date: '2026-01-12T00:00:00',
					purchases: [
						{
							merchantName: 'Browns',
							icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/browns.jpg',
							faceValue: 200,
							savedToSpendEarningsAmount: 23,
							savingPercentage: 11.5,
							usedSavedToSpend: 200
						},
						{
							merchantName: 'ODEON',
							icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/odeon.jpg',
							faceValue: 12,
							savedToSpendEarningsAmount: 0.42,
							savingPercentage: 3.5,
							usedSavedToSpend: null
						}
					]
				},
				{
					date: '2026-01-07T00:00:00',
					purchases: [
						{
							merchantName: 'Caffè Nero',
							icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/caffe-nero.jpg',
							faceValue: 100,
							savedToSpendEarningsAmount: 9.5,
							savingPercentage: 9.5,
							usedSavedToSpend: null
						}
					]
				},
				{
					date: '2026-01-05T00:00:00',
					purchases: [
						{
							merchantName: 'Starbucks',
							icon: 'https://assets.sandbox.tillo.dev/v2/images/brands/vouchers/330x214/starbucks.jpg',
							faceValue: 50,
							savedToSpendEarningsAmount: 4.75,
							savingPercentage: 9.5,
							usedSavedToSpend: null
						}
					]
				}
			]
		}
	},
	watch: {
		// 'drawer': {
		// 	handler: function(newValue) {
		// 		if (!newValue)
		// 		{
		// 			this.drawer = true;
		// 			this.rail = true;
		// 		}
		// 	},
		// }
	},
	methods: {
		toggleSection(key) {
			this.sections[key] = !this.sections[key];
		},
		onLoad: async function () {
			console.log(window.location.origin + '/#/');
		},
		handleSwipeItemClick({ item }) {
			console.log('Item clicked:', item);
		},
		handleSwipeAction({ item, action }) {
			console.log('Action clicked:', action.type, 'on item:', item);
		},
		saveForm() {
			console.log('Form saved:', this.formName, this.formEmail);
			this.showFormDialog = false;
		},
		closeMultiPageDialog() {
			this.showMultiPageDialog = false;
			this.currentPage = 1;
		},
		completeMultiPage() {
			console.log('Multi-page dialog completed');
			this.showMultiPageDialog = false;
		},
		prevItem() {
			if (this.paginationCurrentIndex > 0) {
				this.paginationCurrentIndex--;
			}
		},
		nextItem() {
			if (this.paginationCurrentIndex < this.paginationTotalItems - 1) {
				this.paginationCurrentIndex++;
			}
		},
		increaseTotalItems() {
			if (this.paginationTotalItems < 20) {
				this.paginationTotalItems++;
			}
		},
		decreaseTotalItems() {
			if (this.paginationTotalItems > 1) {
				this.paginationTotalItems--;
				// Ensure current index doesn't exceed total items
				if (this.paginationCurrentIndex >= this.paginationTotalItems) {
					this.paginationCurrentIndex = this.paginationTotalItems - 1;
				}
			}
		},
		onNavPanelClick() {
			alert('Nav Panel clicked!');
		},
		onSectionHeaderAction() {
			alert('Section header action clicked!');
		},
		handleVoucherBasketClick(type) {
			console.log(`VoucherBasket clicked: ${type}`);
			alert(`Clicked ${type} VoucherBasket! Ready to proceed to checkout.`);
		},
		handleEditFormClose() {
			console.log('Edit form closed');
		},
		handleEditFormUpdate(data) {
			console.log('Edit form updated:', data);
		},
		handleAccountListItemClick(account) {
			console.log('Account list item clicked:', account);
		},
		handleAccountTypeLozengeClick(data) {
			console.log('Account type lozenge clicked:', data);
		},
		handleShopClick() {
			console.log('Shop button clicked');
		},
		handleViewMoreTransactions() {
			console.log('View more transactions clicked');
		},
		openWalkthroughDrawer() {
			this.$refs.walkthroughDrawer.openDrawer();
		},
		loadSheetWalkthrough() {
			this._getWalkthrough('money-account-types', (result) => {
				console.log('Sheet walkthrough data loaded:', result);
				this.sheetWalkthroughData = result;
			});
		},
		loadStoryWalkthrough() {
			this._getWalkthrough('money-how-it-works', (result) => {
				console.log('Story walkthrough data loaded:', result);
				this.storyWalkthroughData = result;
			});
		},
		handleWalkthroughOpened() {
			console.log('Walkthrough drawer opened');
		},
		handleWalkthroughClosed() {
			console.log('Walkthrough drawer closed');
		},
		openStoryPage() {
			this.$router.push('/story/money-how-it-works');
		}
	},
	mounted: function () {
		this.loadSheetWalkthrough();
		this.loadStoryWalkthrough();
		this.onLoad();
	},
}
</script>

<style scoped>
.title {
	font-size: 14px;
}

.divider {
	width: 48px;
	margin-bottom: 8px;
	margin-top: 8px;
	margin-right: auto;
	margin-left: auto;
	background: var(--Keyline, rgba(51, 40, 71, 0.10));
	height: 4px;
	border-radius: 4px;
}

.drawer {
	border-radius: 16px 16px 0px 0px;
	border: 0px;
	overflow-y: hidden;
}

.topTabButton {
	margin-top: 0px;
}

.mb-0 {
	margin-bottom: 0;
}

.docsPanel {
	background: transparent;
}

.document-content {
	background: white;
	position: relative;
	padding: 15px 30px;
	min-height: 72px;
	cursor: pointer;
	user-select: none;
	width: 100%;
}

.docIcon {
	color: var(--grey-text);
	margin-right: 16px;
}

.docCol {
	font-size: 14px;
	color: var(--text-color);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
	width: 100%;
	display: block;
}

.flex-grow-1 {
	min-width: 0;
	flex: 1 1 auto;
}

.doc-date {
	font-size: 12px;
	color: var(--grey-text);
}

.swipe-container {
	margin-left: -30px;
	margin-right: -30px;
	margin-top: -20px;
	margin-bottom: -20px;
	padding: 0;
	width: calc(100% + 60px);
}

.v-text-field ::v-deep(.v-field) {
	border: 1px solid #413655 !important;
	border-radius: 5px !important;
}

.savings-card-container {
	background: linear-gradient(202deg, #FCE5D4 49.85%, #E0C5C8 100%);
	margin-left: -30px;
	margin-right: -30px;
	padding: 20px 0;
}

.pagination-controls {
	display: flex;
	gap: 10px;
}

.pagination-examples {
	background: #f5f5f5;
	padding: 20px;
	border-radius: 8px;
}

.example-section {
	background: white;
	padding: 15px;
	border-radius: 6px;
	border: 1px solid #e0e0e0;
}

.example-section h4 {
	margin: 0 0 10px 0;
	font-size: 14px;
	color: #666;
}

.voucher-basket-examples {
	background: #f5f5f5;
	padding: 20px;
	border-radius: 8px;
}

.voucher-basket-examples .example-section >>> .voucher-basket-container {
	max-width: 375px;
	margin: 0 auto;
}

.voucher-edit-form-examples {
	background: #f5f5f5;
	padding: 20px;
	border-radius: 8px;
}

.voucher-edit-form-examples .example-section {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.voucher-edit-form-examples .example-section >>> .voucher-edit-form {
	max-width: 375px;
	margin: 0 auto;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
}

.card-account-group-container {
	display: flex;
	gap: 16px;
	overflow-x: auto;
	padding-bottom: 8px;
}

.account-list-items-container {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.account-type-lozenge-container {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 8px;
	max-width: 400px;
}
</style>
